import { isAxiosError } from 'axios';

/**
 * Достаёт осмысленное сообщение об ошибке из axios/HttpError для показа пользователю.
 * http-клиент проекта конвертирует axios-ошибки в HttpError (см. shared/api),
 * поэтому покрываем оба случая: «сырую» axios-ошибку и уже сконвертированный Error.
 */
export const extractApiErrorMessage = (err: unknown, fallback: string): string => {
  if (isAxiosError(err)) {
    return err.response?.data?.message || fallback;
  }

  if (err instanceof Error && err.message) {
    return err.message;
  }

  return fallback;
};
